// extracted by mini-css-extract-plugin
module.exports = {"Container":"visualLabyrinth_Container__671J0","Row":"visualLabyrinth_Row___bjLp"};